import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { VerifierVerificationPermissiblePurposes } from 'src/components/verifier';
import { PermissiblePurposeDeclineModal } from 'src/modals/pemissiblePurpose';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const VerificationPurposesPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Verification Purposes">
      <TableDataProvider>
        <VerifierVerificationPermissiblePurposes />
      </TableDataProvider>

      <PermissiblePurposeDeclineModal />
    </DetailPageLayout>
  );
};
